// extracted by mini-css-extract-plugin
export default {"ncr__details":"ncr__details__296ck","field":"field__2dI1S","label":"label__CKKkZ","value":"value__2wMK9"};